import React from "react";
const DashBoard = () => {
  return (
    <>
      <section className="dashboard">
        <h1>Selecteer een milieustraat in het linkermenu</h1>
      </section>
      <section className="dashboard-image">
        <img src="/logo.svg" alt="" />
      </section>
    </>
  );
};
export default DashBoard;
